module.exports = __webpack_public_path__ + "static/media/pink_image.ad890c0a.webp";